import { Dropdown, Popconfirm, Tooltip, Button } from "antd";
import {
  CloseOutlined,
  EditOutlined,
  EyeOutlined,
  FileDoneOutlined,
  MoreOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { usePWA } from "@seims/shared";

import {
  EVENT_ACTIONS,
  ACTION_CONFIRMATION_CONFIG,
} from "./eventActionConfig";

/**
 * Maps action keys to icons.
 * Pure UI concern.
 */
const ICON_MAP = {
  [EVENT_ACTIONS.EDIT]: <EditOutlined />,
  [EVENT_ACTIONS.VIEW]: <EyeOutlined />,
  [EVENT_ACTIONS.CANCEL]: <CloseOutlined />,
  [EVENT_ACTIONS.CONCLUDE]: <FileDoneOutlined />,
  [EVENT_ACTIONS.ADD_CAPTURER]: <UserAddOutlined />,
};

/**
 * EventActionsMenu
 *
 * Responsibilities:
 * - Render the 3-dot menu trigger
 * - Render menu items
 * - Apply Popconfirm CONDITIONALLY based on config
 * - Emit action key upward
 *
 * Business logic lives in config + parent, not here.
 */

export const EventActionsMenu = ({ actions, event, onAction }) => {

  const { isOnline } = usePWA();

  if (!actions?.length) return null;

  const menuItems = actions?.map((action) => {
    const config = ACTION_CONFIRMATION_CONFIG[action.key];

    // Only wrap in Popconfirm if config exists AND mode === popconfirm
    // Safe default (no confirmation)
    return {
      key: action.key,
      icon: ICON_MAP[action.key],
      danger: config?.danger,
      label: config?.mode === "popconfirm"
        ? (<Popconfirm
            title={config.title(event)}
            description={config.description}
            okText="Confirm"
            cancelText="Cancel"
            onConfirm={() => onAction(action.key)}
          >
            <span className="event-action-item">
              {action.label}
            </span>
          </Popconfirm>)
        : action.label
    };
  });

  return (

<Tooltip title={!isOnline ? "Actions unavailable while offline" : ""}>
  <span>
    <Dropdown
      menu={{
        items: menuItems,
        onClick: ({ key }) => onAction(key),
        className: "event-actions-menu",
      }}
      trigger={["click"]}
            placement="left"
      disabled={!isOnline}
    >
      <MoreOutlined />
    </Dropdown>

  </span>
</Tooltip>
  );
};

